export default __webpack_public_path__ + "static/media/icon-coin-nmr.e98f4ecf.svg";